const WidgetOverrideParams = {
  Draft: "civicscience-widget-draft",
  Natures: "civicscience-widget-natures",
  Question: "civicscience-widget-question",
  Readonly: "civicscience-widget-readonly",
  ShareQuestion: "csw-sid",
  WidgetAdmin1: "csw-wa1",
  WidgetAdmin2: "csw-wa2",
};

export default WidgetOverrideParams;
